import {IVSPlayerRoomInfo} from "../common/utils/http/IResponse.ts";

export enum PageEnum {
    LOGIN = 'login',
    HOME = 'home',
    DAILY_GAME = 'daily_game',
    CHALLENGE = 'challenge',
    AI_CHALLENGE_GAME = 'ai_challenge_game',
    VS_PLAYER_HOME = "vs_player_home",
    VS_PLAYER_WAITING_PAGE = "vs_player_waiting_page",
    VS_PLAYER_SHOCK_PAGE = "vs_player_shock_page",
    VS_PLAYER_GAME_PAGE = "vs_player_game_page",
    WORD_MAKER_HOME = "word_maker_home",
    UGCGamePage="ugc-game-page"
}

export enum GameTypeEnum {
    DAILY = 'daily',
    CHALLENGE = 'ai'
}

export enum VsPlayerLevel {
    EASY = 1,
    MEDIUM = 2,
    HARD = 3
}


export interface PageProps {
    currentPage?: PageEnum;
    switchPage: (page: PageEnum) => void;
}

export interface UGCPageProps {
    currentPage?: PageEnum;
    switchPage: (page: PageEnum) => void;
    nextUGCGame: () => void;
}

export interface PagePropsWithVs {
    currentPage?: PageEnum;
    switchPage: (page: PageEnum) => void;
    vsPlayerInfo?: IVSPlayerRoomInfo;
}

export interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
}
